import React, { useContext } from "react";

import { A11y as BackButton } from "@churchofjesuschrist/eden-buttons";
import { ChevronLeftLarge as BackIcon } from "@churchofjesuschrist/eden-icons";
import {
  spacing16 as columnGutter,
  spacing16 as mainMargin,
} from "@churchofjesuschrist/eden-style-constants";
import styled from "styled-components";

import MobileViewContext from "../../global-layout/mobile/mobile-view-context";
import ShadowCircleIcon from "../shadow-circle-icon/shadow-circle-icon";

const Columns = styled.div`
  display: flex;
  margin: ${mainMargin} 0;
  min-width: 0;
`;

const Back = styled(BackButton)`
  max-width: 40px;
  height: 40px;
  margin-right: ${columnGutter};
`;
const Right = styled.div`
  flex: 1;
  min-width: 0;
`;

const ContentWithIcon = ({
  onBackClick = () => {},
  children,
  icon,
  ...others
}) => {
  const { isMobile } = useContext(MobileViewContext);
  const size = isMobile ? "small" : "large";
  return (
    <Columns {...others}>
      <Back onClick={onBackClick} data-id="content-icon-navigation">
        <ShadowCircleIcon size={size}>{icon ? icon : <BackIcon data-id="back-icon" />}</ShadowCircleIcon>
      </Back>
      <Right>{children}</Right>
    </Columns>
  );
};

export default ContentWithIcon;

/* */
